import { computed, ref } from 'vue'

import IconActionConfig from '@/components/atoms/icons/IconActionConfig.vue'
import IconAffiliates from '@/components/atoms/icons/IconAffiliates.vue'
import IconDashboard from '@/components/atoms/icons/IconDashboard.vue'
import IconDesign from '@/components/atoms/icons/IconDesign.vue'
import IconHelp from '@/components/atoms/icons/IconHelp.vue'
import IconPages from '@/components/atoms/icons/IconPages.vue'
import IconOpportunities from '@/components/atoms/icons/IconOpportunities.vue'
import IconSubscriptions from '@/components/atoms/icons/IconSubscriptions.vue'
import api from '@/services/api'
import notification from '@/services/notification'
import { useApplicationStore } from '@/stores/application'
import { useSiteStore } from '@/stores/site'
import { BETA_PANEL_QUERY_KEY } from '@/utils/panel-variant'

export const useBetaPanelNavigation = (options: {
    beforeOpenDesign?: () => boolean | Promise<boolean>
} = {}) => {
    const applicationStore = useApplicationStore()
    const siteStore = useSiteStore()
    const openingDesign = ref(false)

    const navItems = computed(() => [
        { id: 'home' as const, label: 'Início', icon: IconDashboard },
        { id: 'content' as const, label: 'Páginas', icon: IconPages },
        { id: 'appearance' as const, label: 'Aparência', icon: IconDesign },
        { id: 'settings' as const, label: 'Configurações', icon: IconActionConfig },
        { id: 'opportunities' as const, label: 'Oportunidades', icon: IconOpportunities },
        ...(applicationStore.className === 'epics' ? [] : [
            { id: 'subscriptions' as const, label: 'Assinaturas', icon: IconSubscriptions },
            { id: 'affiliates' as const, label: 'Afiliados', icon: IconAffiliates },
        ]),
        { id: 'help' as const, label: 'Ajuda', icon: IconHelp },
    ])

    const openDesign = async () => {
        if (openingDesign.value) return

        openingDesign.value = true

        try {
            if (options.beforeOpenDesign && !await options.beforeOpenDesign()) return

            const response = await api.get(`site/${siteStore.id}/design/access`)
            const data = await response.json() as {
                status?: string | number
                message?: string
                url?: string
            }

            if (data.status != 1 || !data.url) {
                throw new Error(data.message || 'Não foi possível abrir o painel de Design.')
            }

            const url = new URL(data.url, window.location.href)
            url.searchParams.set('urlPanel', window.location.host)
            url.searchParams.set(BETA_PANEL_QUERY_KEY, '')
            window.location.replace(url.toString())
        } catch (error) {
            notification.simple(
                error instanceof Error
                    ? error.message
                    : 'Não foi possível abrir o painel de Design.',
                'error',
            )
        } finally {
            openingDesign.value = false
        }
    }

    return { navItems, openingDesign, openDesign }
}
